/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Title_SkillsInputs */

const en_resume_title_skills = /** @type {(inputs: Resume_Title_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skills`)
};

const ar_resume_title_skills = /** @type {(inputs: Resume_Title_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المهارات`)
};

const bn_resume_title_skills = /** @type {(inputs: Resume_Title_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দক্ষতা`)
};

const de_resume_title_skills = /** @type {(inputs: Resume_Title_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fähigkeiten`)
};

const es_resume_title_skills = /** @type {(inputs: Resume_Title_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilidades`)
};

const fr_resume_title_skills = /** @type {(inputs: Resume_Title_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compétences`)
};

const pt_resume_title_skills = /** @type {(inputs: Resume_Title_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilidades`)
};

const zh_resume_title_skills = /** @type {(inputs: Resume_Title_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技能`)
};

const tr_resume_title_skills = /** @type {(inputs: Resume_Title_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beceriler`)
};

const ru_resume_title_skills = /** @type {(inputs: Resume_Title_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Навыки`)
};

const pl_resume_title_skills = /** @type {(inputs: Resume_Title_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umiejętności`)
};

/**
* | output |
* | --- |
* | "Skills" |
*
* @param {Resume_Title_SkillsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_title_skills = /** @type {((inputs?: Resume_Title_SkillsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Title_SkillsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_title_skills(inputs)
	if (locale === "bn") return bn_resume_title_skills(inputs)
	if (locale === "de") return de_resume_title_skills(inputs)
	if (locale === "es") return es_resume_title_skills(inputs)
	if (locale === "fr") return fr_resume_title_skills(inputs)
	if (locale === "pt") return pt_resume_title_skills(inputs)
	if (locale === "zh") return zh_resume_title_skills(inputs)
	if (locale === "tr") return tr_resume_title_skills(inputs)
	if (locale === "ru") return ru_resume_title_skills(inputs)
	if (locale === "pl") return pl_resume_title_skills(inputs)
	return en_resume_title_skills(inputs)
});